/**
 * Parse a DECKEE_CONFIG value as an integer, falling back to `defaultValue`
 * only when the raw value is missing or non-numeric.  Unlike `parseInt(…) || default`,
 * this preserves `0` as a valid configured value.
 */
export function parseConfigInt(
  raw: string | number | undefined | null,
  defaultValue: number,
): number {
  const parsed = parseInt(String(raw ?? ''), 10);
  return Number.isNaN(parsed) ? defaultValue : parsed;
}
